import { container } from "@di/inversify.config";
import { AuthenticatedUserIsLoggedUseCase } from "@iot-platform/authentication";
import { LoginRoutes } from "@routes/public/login.routes";
import type { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

export const RequireAuthGuard: FC = () => {
    const location = useLocation();
    const isUserLogged = container
        .get(AuthenticatedUserIsLoggedUseCase)
        .execute();

    return isUserLogged ? (
        <Outlet />
    ) : (
        <Navigate
            to={LoginRoutes.LOGIN}
            state={{ from: location }}
            replace
        />
    );
};
